import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {type IAsset} from '../schema';
import {assetIsPresent} from './assetIsPresent';

export const canZoomAsset = (asset?: IAsset) =>
	assetIsPresent(asset) &&
	(getPreference('zoom.tiles.enabled', true) ||
		(getPreference('equilibrium.enabled', true) &&
			getPreference('equilibrium.zoomEnabled', true))) &&
	asset.zoomAvailable &&
	// HACKaround for HTML-868:
	asset.filewidth > 0 &&
	asset.fileheight > 0;
